import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {injectIntl} from 'react-intl';
import { hasFeatureFlag } from '../../forecast-app/shared/util/FeatureUtil';

class MyWorkSectionHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hoveringSectionLink: false,
		};
	}

	componentDidUpdate(prevProps) {
		let prevPathEnding = localStorage.getItem('my-work-section-last-viewed');
		const thisPathEnding = this.props.history.location.pathname.split('//(.+)/').pop();
		const myWorkPath = ['/', '/timesheets', '/expenses'];
		if (this.props.myWorkScheduling) {
			myWorkPath.push('/scheduling');
		}
		if (thisPathEnding !== prevPathEnding && this.props.setMyWorkLastSection && myWorkPath.includes(thisPathEnding)) {
			this.props.setMyWorkLastSection(thisPathEnding);
		}
	}

	getActiveIndicator() {
		return (
			<div className="active-indicator">
				<div className="border" />
			</div>
		);
	}
	onSectionLinkMouseEnter() {
		this.setState({hoveringSectionLink: true});
	}
	onSectionLinkMouseLeave() {
		this.setState({hoveringSectionLink: false});
	}
	navigationV2(navLinkBase, formatMessage) {
		return (
			<div className="my-profile-section-header">
				<nav className=" section-navigation old">
					<ul>
						<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-work-header-nav-point-tasks'} data-userpilot={'header-my-tasks'}>
							<NavLink exact to={`/`} isActive={(match, location) => location.pathname.match(/^\/(T\d+)?$/)} className="my-tasks" activeClassName="active">
								<span title={formatMessage({id: 'header.my_tasks'})}>{formatMessage({id: 'header.my_tasks'})}</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
					</ul>
					{(this.props.isClientUser || hasFeatureFlag('no_time_reg')) ? null : (
						<ul>
							<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-work-header-nav-point-timesheet'} data-userpilot={'header-my-timesheets'}>
								<NavLink to={`/timesheets`} className="timesheets" activeClassName="active">
									<span title={formatMessage({id: 'timesheet.my_timesheet'})}>{formatMessage({id: 'timesheet.my_timesheet'})}</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						</ul>
					)}
					{this.props.isClientUser || !this.props.hasFinance ? null : (
						<ul>
							<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-work-header-nav-point-expenses'} data-userpilot={'header-my-expenses'}>
								<NavLink to={`/expenses`} className="expenses" activeClassName="active">
									<span title={formatMessage({id: 'my_profile.my_expenses'})}>{formatMessage({id: 'my_profile.my_expenses'})}</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						</ul>
					)}
					{this.props.myWorkScheduling ? (
						<ul>
							<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-work-header-nav-point-schedule'} data-userpilot={'header-my-schedule'}>
								<NavLink exact to={'/scheduling#people'} isActive={(match, location) => location.pathname === '/scheduling'} className="scheduling-people" activeClassName="active">
									<span title={formatMessage({id: 'header.my_schedule'})}>{formatMessage({id: 'header.my_schedule'})}</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						</ul>
					) : null}
				</nav>
			</div>
		);
	}
	render() {
		const {formatMessage} = this.props.intl;
		const navLinkBase = `/`;
		return (
			<section>
				<div className={'section-main v2'}>{this.navigationV2(navLinkBase, formatMessage)}</div>
			</section>
		);
	}
}

export default withRouter(injectIntl(MyWorkSectionHeader));
